import { render } from "./OrderImport.vue?vue&type=template&id=652a8c8d"
import script from "./OrderImport.vue?vue&type=script&lang=js"
export * from "./OrderImport.vue?vue&type=script&lang=js"

import "./OrderImport.vue?vue&type=style&index=0&id=652a8c8d&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__